import React from 'react';

function Info() {
    return (
        <svg width="19" height="19" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.833344 9.99967C0.833344 4.93706 4.9374 0.833008 10 0.833008C15.0626 0.833008 19.1667 4.93706 19.1667 9.99967C19.1667 15.0623 15.0626 19.1663 10 19.1663C4.9374 19.1663 0.833344 15.0623 0.833344 9.99967ZM10 2.49967C5.85787 2.49967 2.50001 5.85754 2.50001 9.99967C2.50001 14.1418 5.85787 17.4997 10 17.4997C14.1421 17.4997 17.5 14.1418 17.5 9.99967C17.5 5.85754 14.1421 2.49967 10 2.49967Z"
                fill="#4A6987"
            />
            <line x1="10.1667" y1="9.375" x2="10.1667" y2="14.7917" stroke="#4A6987" strokeWidth="2" />
            <path
                d="M10.0052 7.75009C10.6338 7.75009 11.1718 7.22807 11.1771 6.57821C11.1718 5.93901 10.6338 5.41699 10.0052 5.41699C9.35537 5.41699 8.82803 5.93901 8.83335 6.57821C8.82803 7.22807 9.35537 7.75009 10.0052 7.75009Z"
                fill="#4A6987"
            />
        </svg>
    );
}

export default Info;
